import get from '../../utils/object/get';
import fromTheme from './fromTheme';

const boxShadow = (shadowPath: 1 | 2) => fromTheme((theme) => get(`${shadowPath}`, theme.boxShadow));

export default boxShadow;
